<template>
  <div class="bg-gray-100">
   
     <!-- Header -->
     <div class="flex items-center p-4">
                <button
                    :class="$colors.primary"
                    class="rounded-full flex justify-center items-center w-9 h-9 mr-3"
                    @click="RouterBack()"
                >
                    <i class="material-icons">chevron_left</i>
                </button>
                <div class="text-lg md:text-xl font-semibold text-green-600">
                    {{ formData._id ? $t('update_order') : $t('new_order') }}
                </div>
      </div>

      <!-- ********************************************************Customer information **********************************-->

      <div class="px-6 mt-3">
        <!-- WRAPPER: عمود فالموبايل / جوج أعمدة من md+ -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">

            <!-- =============== Customer information =============== -->
            <div class="w-full bg-white shadow-xs rounded-lg p-4">
              <div class="flex items-center mb-3">
                <span class="rounded-full h-10 w-10 bg-gray-100 flex items-center justify-center">
                  <i class="material-icons text-green-400">person</i>
                </span>
                <div class="ml-3 text-base font-semibold text-gray-700">
                  {{$t('customer_information')}}
                </div>
              </div>

              <div class="space-y-4">
                <!-- Country -->
                <div>
                  <label class="block text-xs text-gray-700 mb-1">{{$t('country')}}</label>
                  <v-select
                    @input="setSelected"
                    v-model="formData.customer.country"
                    :options="warehousesusers"
                    label="name"
                    class="w-full border rounded"
                  >
                    <template slot="option" slot-scope="option">
                      <img class="flag-img" :src="$f.getCountryCode(option.code)" />
                      {{ option.name }}
                    </template>
                  </v-select>
                </div>

                <!-- Full name -->
                <div>
                  <label class="block text-xs text-gray-700 mb-1">
                    {{$t('full_name')}} <span :class="$colors.required">*</span>
                  </label>
                  <input
                    id="customerFullName"
                    type="text"
                    v-model="formData.customer.fullName"
                    class="w-full text-sm border rounded px-2 py-2 focus:outline-none focus:ring-1 focus:ring-green-500"
                  />
                </div>

                <!-- Phone -->
                <div>
                  <label class="block text-xs text-gray-700 mb-1">
                    {{$t('phone')}} <span :class="$colors.required">*</span>
                  </label>
                  <input
                    id="customerPhone"
                    type="text"
                    v-model="formData.customer.phone"
                    class="w-full text-sm border rounded px-2 py-2 focus:outline-none focus:ring-1 focus:ring-green-500"
                  />
                </div>

                <!-- City -->
                <div>
                  <label class="block text-xs text-gray-700 mb-1">
                    {{$t('city')}} <span :class="$colors.required">*</span>
                  </label>
                  <v-select
                    class="w-full border rounded"
                    @input="setSelectedCity"
                    v-model="formData.customer.city"
                    :options="cities"
                  />
                </div>

                <!-- Shipping cost (MA only) -->
                <div v-if="formData.customer.city && feesShipp && selectContry === 'MA'">
                  <label class="block text-xs text-gray-700 mb-1">
                    {{$t('shipping_cost')}} <sup>({{currentCurrency}})</sup>
                  </label>
                  <input
                    id="Frais"
                    disabled
                    :value="feesShipp"
                    type="text"
                    class="w-full text-sm border rounded px-2 py-2 bg-gray-50"
                  />
                </div>

                <!-- Address -->
                <div>
                  <label class="block text-xs text-gray-700 mb-1">{{$t('adress')}}</label>
                  <textarea
                    id="customerAddress"
                    v-model="formData.customer.address"
                    class="w-full text-sm border rounded px-2 py-2 focus:outline-none focus:ring-1 focus:ring-green-500"
                  ></textarea>
                </div>
              </div>
            </div>

            <!-- =============== Order information =============== -->
            <div class="w-full bg-white shadow-xs rounded-lg p-4">
              <div class="flex items-center mb-3">
                <span class="rounded-full h-10 w-10 bg-gray-100 flex items-center justify-center">
                  <i class="material-icons text-green-400">local_grocery_store</i>
                </span>
                <div class="ml-3 text-base font-semibold text-gray-700">
                  {{$t('order_information')}}
                </div>
              </div>

              <div class="space-y-4">
                <!-- Source -->
                <div>
                  <label class="block text-xs text-gray-700 mb-1">{{$t('order_source')}}</label>
                  <input
                    id="source"
                    type="text"
                    v-model="formData.source"
                    class="w-full text-sm border rounded px-2 py-2 focus:outline-none focus:ring-1 focus:ring-green-500"
                  />
                </div>

                <!-- Source link -->
                <div>
                  <label class="block text-xs text-gray-700 mb-1">{{$t('order_source_link')}}</label>
                  <input
                    id="sourceLink"
                    type="text"
                    v-model="formData.sourceLink"
                    class="w-full text-sm border rounded px-2 py-2 focus:outline-none focus:ring-1 focus:ring-green-500"
                  />
                </div>

                <!-- Shipping date -->
                <div v-if="currentUser.type !== 'Seller'">
                  <label class="block text-xs text-gray-700 mb-1">
                    Shipping date <span :class="$colors.required">*</span>
                  </label>
                  <datetime-v2
                    :min-datetime="$moment(Date.now()).format('yyyy-MM-DD')"
                    v-model="formData.shippingdate"
                    placeholder="Shipping date ..."
                    input-class="w-full text-sm border rounded px-2 py-2 focus:outline-none"
                  />
                </div>

                <!-- Seller (not Seller role) -->
                <div
                  v-if="(currentUser && currentUser.type && currentUser.type !== 'Seller') && formData.customer.country"
                >
                  <label class="block text-xs text-gray-700 mb-1">
                    {{$t('seller')}} <span :class="$colors.required">*</span>
                  </label>
                  <v-select
                    class="w-full border rounded"
                    label="fullName"
                    :disabled="formData && formData._id ? true : false"
                    @search="searchSellers($event,'hh')"
                    @input="changeSeller"
                    v-model="formData.seller"
                    :options="sellers"
                  />
                </div>

                <div  v-if="currentUser.type !== 'Seller'">
                  <label class="block text-xs text-gray-700 mb-1">{{$t('Commentaire')}}</label>

                  <textarea autocomplete="false" tabindex="0" :disabled="formData._id && formData.status && formData.status.name == 'Confirmed'"
                      type="text" v-model="formData.comment"
                      class="w-full text-sm border rounded px-2 py-2 focus:outline-none focus:ring-1 focus:ring-green-500" />
                </div>

              </div>
            </div>

          </div>

        <!-- ********************************************************Product Table assigned to order **********************************-->

        <div v-if="formData.customer.country && formData.seller" class="w-full">
          <div class="w-full shadow-xs mt-1 rounded-lg bg-white">
            <div class="flex items-center justify-between p-4">
              <div class="flex items-center">
                <span class="rounded-full h-10 w-10 bg-gray-100 flex items-center justify-center">
                  <i class="material-icons text-green-500">local_mall</i>
                </span>
                <p class="ml-3 text-base font-semibold text-gray-700">{{$t('products')}}</p>
              </div>

              <button
                :class="!formData._id && formData.details.length==0 ? 'animation-pulse' : ''"
                @click="OpenPopUp"
                class="flex items-center justify-center bg-green-600 text-white rounded-md px-4 py-2 focus:outline-none disabled:opacity-60"
                :disabled="isDisabled || (formData.status && formData.status.name === 'Confirmed' ? true : false)"
              >
                {{$t('select_product')}}
              </button>
            </div>

            <!-- ====== Mobile (cards) ====== -->
            <div class="block md:hidden px-4 pb-2 space-y-3">
              <div
                v-for="(item, index) in formData.details"
                :key="index"
                class="border rounded-lg p-3"
              >
                <!-- Title + delete -->
                <div class="flex items-start justify-between">
                  <div class="font-semibold text-gray-800 truncate">
                    {{ item.product.name }}
                  </div>
                  <button
                    @click="removeProduct(item, index)"
                    :disabled="formData.status && formData.status.name === 'Confirmed' ? true : false"
                    class="w-8 h-8 rounded-full flex items-center justify-center text-red-600 hover:bg-red-50 focus:outline-none disabled:opacity-60"
                  >
                    <i class="material-icons">delete</i>
                  </button>
                </div>

                <!-- Unit price -->
                <div class="mt-2">
                  <label class="block text-xs text-gray-500 mb-1">{{$t('unit_price')}}</label>
                  <input
                    type="number"
                    min="0"
                    v-model.number="item.unitPrice"
                    :disabled="formData.status && formData.status.name === 'Confirmed' ? true : false"
                    class="w-full border rounded px-2 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-green-500 disabled:bg-gray-50"
                  />
                </div>

                <!-- Quantity controls -->
                <div class="mt-3">
                  <label class="block text-xs text-gray-500 mb-1">{{$t('quantity')}}</label>
                  <div class="flex items-center gap-3">
                    <button
                      class="bg-green-600 text-white rounded w-8 h-8 flex items-center justify-center focus:outline-none disabled:opacity-60"
                      @click="addQuantity(index)"
                      :disabled="formData.status && formData.status.name === 'Confirmed' ? true : false"
                    >
                      <i class="material-icons">add</i>
                    </button>

                    <input
                      class="w-16 text-center border rounded px-2 py-1 text-sm focus:outline-none"
                      type="number"
                      min="0"
                      v-model.number="item.quantity"
                      :disabled="formData.status && formData.status.name === 'Confirmed' ? true : false"
                    />

                    <button
                      class="bg-green-600 text-white rounded w-8 h-8 flex items-center justify-center focus:outline-none disabled:opacity-60"
                      @click="removeQuantity(index)"
                      :disabled="formData.status && formData.status.name === 'Confirmed' ? true : false"
                    >
                      <i class="material-icons">remove</i>
                    </button>
                  </div>
                </div>

                <!-- Line total -->
                <div class="mt-3 flex items-center justify-between">
                  <span class="text-xs text-gray-500">{{$t('total')}}</span>
                  <span class="font-semibold text-gray-900">
                    {{ (item.unitPrice || 0) * (item.quantity || 0) }}
                    <sup class="text-black">({{currentCurrency}})</sup>
                  </span>
                </div>
              </div>

              <!-- Cart total -->
              <div class="pt-1 pb-4 flex items-center justify-end">
                <div class="text-sm font-bold text-gray-900">
                  {{$t('total_price')}}: {{ TotalPrice() }}
                  <sup class="text-black">({{currentCurrency}})</sup>
                </div>
              </div>
            </div>

            <!-- ====== Desktop (table) ====== -->
            <div class="hidden md:block px-4 pb-4">
              <div class="overflow-x-auto">
                <table v-if="formData.details && formData.details.length" class="min-w-full leading-normal">
                  <thead>
                    <tr>
                      <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        {{$t('name')}}
                      </th>
                      <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        {{$t('unit_price')}}
                      </th>
                      <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        {{$t('quantity')}}
                      </th>
                      <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        {{$t('total')}}
                      </th>
                      <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        {{$t('actions')}}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(item, index) in formData.details" :key="index">
                      <!-- name -->
                      <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                        <div class="text-xs leading-5 text-gray-900 truncate">
                          {{ item.product.name }}
                        </div>
                      </td>

                      <!-- unit price -->
                      <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                        <input
                          type="number"
                          min="0"
                          v-model.number="item.unitPrice"
                          :disabled="formData.status && formData.status.name === 'Confirmed' ? true : false"
                          class="border border-green-600 rounded px-2 py-1 text-xs w-28 focus:outline-none disabled:bg-gray-50"
                        />
                      </td>

                      <!-- quantity -->
                      <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                        <div class="flex items-center gap-4">
                          <button
                            class="bg-green-600 text-white rounded w-6 h-6 flex items-center justify-center focus:outline-none disabled:opacity-60"
                            @click="addQuantity(index)"
                            :disabled="formData.status && formData.status.name === 'Confirmed' ? true : false"
                          >
                            <i class="material-icons text-sm">add</i>
                          </button>

                          <input
                            class="w-12 text-center border rounded px-2 py-1 text-xs focus:outline-none"
                            type="number"
                            min="0"
                            v-model.number="item.quantity"
                            :disabled="formData.status && formData.status.name === 'Confirmed' ? true : false"
                          />

                          <button
                            class="bg-green-600 text-white rounded w-6 h-6 flex items-center justify-center focus:outline-none disabled:opacity-60"
                            @click="removeQuantity(index)"
                            :disabled="formData.status && formData.status.name === 'Confirmed' ? true : false"
                          >
                            <i class="material-icons text-sm">remove</i>
                          </button>
                        </div>
                      </td>

                      <!-- total -->
                      <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                        <div class="text-xs font-semibold text-gray-900">
                          {{ (item.unitPrice || 0) * (item.quantity || 0) }}
                          <sup class="text-black">({{currentCurrency}})</sup>
                        </div>
                      </td>

                      <!-- actions -->
                      <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                        <div class="flex justify-center">
                          <button
                            @click="removeProduct(item, index)"
                            :disabled="formData.status && formData.status.name === 'Confirmed' ? true : false"
                            class="rounded-full w-8 h-8 flex items-center justify-center text-red-600 hover:bg-red-50 focus:outline-none disabled:opacity-60"
                          >
                            <i class="material-icons">delete</i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>

                  <tfoot>
                    <tr>
                      <td colspan="5" class="px-6 py-2 text-right">
                        <div class="text-xs font-bold text-gray-900">
                          {{$t('total_price')}}: {{ TotalPrice() }}
                          <sup class="text-black">({{currentCurrency}})</sup>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <!-- فاش ماكايناش ديتا -->
                <div v-else class="text-center text-sm text-gray-500 py-6">
                  {{$t('no_data')}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ************************************************************************************************-->
      </div>

      <div class="my-5 pt-3 flex justify-center px-4 md:px-10">
        <button
          @click="save"
          :disabled="loading"
          class="relative inline-flex items-center justify-center rounded-md
                bg-green-600 text-white px-4 py-2
                w-full sm:w-1/2 md:w-1/3 lg:w-1/4
                font-medium transition
                hover:bg-green-700
                focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2
                disabled:opacity-60 disabled:cursor-not-allowed"
          :class="loading ? 'pointer-events-none' : ''"
        >
          <!-- loader داخل الزر -->
          <loading :active.sync="loading" :is-full-page="false"></loading>

          <span v-if="!loading">{{$t('save')}}</span>
          <span v-else class="pl-6">{{$t('saving') || 'Saving...'}}</span>
        </button>
      </div>

      <!-- ***********************************Pop up Affectation products to Order************************************************ -->

        <vue-modal-2  name="myModal" :headerOptions="{title: $t('add_products')}" :noFooter="true" modalSize="lg" @on-close="closePopUp('myModal')">
        <div class="flex flex-col w-full h-auto p-5 pt-0 mb-12">
          <!-- Header -->
          <div class="flex w-full h-auto justify-center items-center">
            <div
              class="flex mb-2 w-full h-auto py-2 justify-center items-center text-2xl font-bold"
            >
              <span
                class="w-screen md:w-full h-10 cursor-pointer border border-gray-200 rounded text-sm flex"
              >
                <input
                  type="search"
                  name="search"
                  v-model="searchText"
                  placeholder="Search"
                  class="flex-grow px-4 rounded-l-full rounded-r-full text-sm focus:outline-none"
                />
                <i class="material-icons text-blue-400 m-2 mr-5 text-lg w-4 h-4"
                  >search</i
                >
              </span>
            </div>
          </div>
          <div>
            <div v-if="products.length <= 0" class="py-2">
              <span
                class="w-full flex justify-center text-center py-20 border-b border-gray-200 text-base"
              >
                <p class="font-semibold flex text-blue-500 whitespace-no-wrap">
                  <span class=""> {{$t('no_products_found')}}</span>
                </p>
              </span>
            </div>
            <div
              v-for="(item, index) in resultSearchUsers"
              :key="index"
              :value="item._id"
              class="flex w-full space-x-12 h-auto py-1 px-8 rounded border border-gray-300 mb-2" :style="item.type && item.type === 'affiliate'?'background: linear-gradient(90deg, #ed0e0e, rgb(25 166 157 / 4%));':''">
              <div>
                <input
                  type="checkbox"
                  :class="'product-'+index"
                  class="form-checkbox mt-6 h-5 w-5 text-blue-500 border-blue-500"
                  @change="addProductsToTemp(item,index)"
                  v-model="item.check"
                />
              </div>

              <div>
                <img
                  :alt="item.name"
                  :src="item.picture||'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"
                  class="h-16 w-16 rounded-md mx-auto"
                />
              </div>
              <div class="col-span-2 sm:col-span-4 xl:col-span-4">
                <h3 class="text-gray-80 mt-1">{{ item.name }}</h3>
                <p v-if="item.type === 'normal'" class="text-gray-600 text-xs">{{ exceptDes(item.description) }}</p>
                <p v-if="item.type === 'affiliate'" class="text-gray-700 text-xs uppercase">Offre affiliate</p>
              </div>

             <!-- <div class="mt-4">
                <div
                  class="justify-center text-xs text-center pl-3 pr-2 w-auto bg-blue-100 font-semibold rounded-full text-blue-500"
                >
                  <p>{{ item.price }} <sup class="text-black">{{$f.getcurrencyCodeByCountry(options,selectContry) }}</sup></p>
                </div>
              </div>-->
              
            </div>
          </div>
        </div>

        <div class="modal-footer px-5 border0-t text-right">
          <button
            @click="closePopUp('myModal')"
            class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            
            {{$t('cancel')}}
          </button>
          <button
            @click="ConfirmOperation"
            class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            {{$t('confirm')}}
          </button>
        </div>
      </vue-modal-2>
      <!-- ******************************************************** -->

      <vue-modal-2 name="warehouseParent" :headerOptions="{title: 'Choisir la ville de stockage'}" :noFooter="true" modalSize="md">
            <div class="flex flex-col w-full h-auto">
            <!-- Header -->
            <!-- Modal Content-->
            <div class="bg-white rounded px-2  pb-2 flex flex-col">
               <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                <p class="font-bold text-center">S'il vous plait Choisir la ville de stockage de produit</p>
                <div  class="shadow bg-white my-2 p-1 border-2 border-gray-500 rounded svelte-1l8159u">
                      <v-select  v-model="formData.zone" :options="checkWraehouseParent" label="name"></v-select>
                </div>
                <div class="flex p-2 mt-4">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loading" @click="save('warehouseParent')" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> {{$t('confirm')}}</button>
                          <button :disabled="loading"  @click="closePopUp('warehouseParent')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
                      </div>
                  </div>
            </div>
            <!-- End of Modal Content-->
          </div>
      </vue-modal-2>

  </div>
</template>



<script>
export default {
  data() {
    return {
      formData: {
        source: "",
        affiliate:{},
        sourceLink: "",
        totalPrice:0,
        shippingdate:this.$momentTimezone.tz(this.$moment(),'UTC').format(),
        customer: {
          fullName: "",
          phone: "",
          city: "",
          //  shippingAddress: "",
        },
        details: [],
        status: "",
        seller: null,
      },
      currentUser: {
        role: {},
      },
      searchText: "",
      quantity: 0,
      status: [],

      products: [],
      show_modal: true,
      limit: 10,
      warhouseId:null,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
      },
      productselected: [],
      numberItemRepeated: 0,
      sellers: [],
      isDisabled: true,
      sellerExists:false,
      options: this.$countries,
      selectContry:"",
      warehouses:[],
      warehousesusers:[],
      currentCurrency:"",
      cities:[],
      feesShipp:null,
      loading:false,
      fullPage: false,
      checkWraehouseParent:[],
      sous_warehouses:[],
      zones:[],
    };
  },
  async mounted() {
    await this.getUser();
    if(this.currentUser.type == "Seller") {
        this.formData.seller = this.currentUser;
        if (this.formData.seller) this.isDisabled = false;
        console.log('isDisabled-----',this.isDisabled)
    }

    await this.getStatus();
    await this.dataToEdit();
    this.dateMin();
     console.log('isDisabled final-----',this.isDisabled)
  },
  methods: {
      RouterBack: function() {
                this.$router.back();
            },
     async getCurrency(){
      await this.$store.dispatch('wharhouse/getCurrency').then((res) => {
            this.currency=res;
        })
    },
    searchSellers: _.debounce(async function(search) {
      if(this.selectContry){
        const filter = {
          type: "Seller",
          limit:10,
          countries: this.selectContry,
          name: search,
        };
        const res= await this.$server.find("users",filter);

      if (res.content.results) this.sellers = res.content.results;
      else this.sellers = [];
      }
     
    }, 500),
    getElementInArray(data,value){
        var result  = data.filter(function(o){
            let whar=o.warehouse;
            if(o.warehouse._id) whar=o.warehouse._id;
            return whar == value.toString();
        } );
        return result? result[0] : null; // or undefined
    },
    async getWarehouses(){
        const filter = {limit:10};
        const res = await this.$server.search("warehouses",filter);
        if (res.content.results) {
            let data = res.content.results;
            for(let i in data){
              this.warehouses.push({name:this.$f.getCountryNameByCode(this.options,data[i].country),code:data[i].country})
            }
        } else this.warehouses = [];
    }, 
    async getZones() {
      if(this.selectContry){
        if (this.currentUser.type != "Seller") {
            const res = await this.$server.search("zones",{ limit: 100,country:this.selectContry});
            if (res.content.results) this.zones = res.content.results;
            else this.zones = [];
        } else {
          this.zones = [];
        }
      }
    },
    async getCities(country){
      const resCities = await this.$server.get("zones", { allCities: true,country:country}); 
            if(resCities.content.length>0)  this.cities= resCities.content;
            else this.cities=[];
    },
    async getCurrencyBycontry(country){
          const resW = await this.$server.get("warehouses", { country: country}); 
          this.currentCurrency=resW.content.currency;
          this.warhouseId=resW.content;
    },
    async setSelected(contry) {
       if(contry){
         this.formData.details = [];this.sous_warehouses=[];
         this.formData.customer.country=contry.name;
         this.selectContry=contry.code;
         if (this.currentUser && this.currentUser.type && this.currentUser.type != "Seller") await this.getSellers(contry.code);
         await this.getCities(contry.code);
         await this.getZones();
         await this.getCurrencyBycontry(contry.code);
         if(['NRP',"CEO",'Return','CancelledOrder','TeleConsultant','Admin','ToRemind'].indexOf(this.currentUser.type) != -1){
            const resW = await this.$server.search("warehouses", { country: contry.code,all:true,limit:10}); 
            if(resW.content && resW.content.results) this.sous_warehouses=resW.content.results.filter(item => !item.is_primary);
         }
       }
    },
    async getFeesShippBycity(city){
        const res = await this.$server.search("zones",{cities:city});
        if(res.content.results) this.feesShipp=res.content.results[0].price;
    },
    async setSelectedCity(city){
      if(city){
         await this.getFeesShippBycity(city);
       } else this.feesShipp=null
    },
    dateMin(){ 
      // document.getElementById('date').setAttribute('min', this.$moment(Date.now()).format('yyyy-MM-DD')); 
    },
    exceptDes(text){
         if (text && text.length > 60) text = text.substring(0, 60) + "...";
      return text;
    },
    // changeSeller(seller) {
    //   console.log('seller_____________',seller  )
    //   if (this.formData.seller) {
    //     this.isDisabled = false;
    //     if (this.formData.details) {
    //       if (this.formData.details[0]) {
    //         if (
    //           this.formData.details[0].product.seller !=
    //           this.formData.seller._id
    //         ) {
    //           this.formData.details = [];
    //         }
    //       }
    //     }
    //   } else {
    //     this.isDisabled = true;
    //   }
    // },
    TotalPrice(){
      let Total=0;
        for (const element of this.formData.details) {
            Total+=element.unitPrice * element.quantity;
        }
        this.formData.totalPrice=Total;
        return Total;
     },
    async getUser() {
      const res = await this.$server.me("users");
      //console.log(res);
      if (res.content) {
          this.currentUser = res.content;
          await this.getWarehouses();
          for (let i in this.warehouses) {
            for (let j in this.currentUser.countries) {
                if(this.warehouses[i].code===this.currentUser.countries[j]) this.warehousesusers.push(this.warehouses[i]);
            }
          }
      }else {this.currentUser = {};this.warehousesusers=[]}
      //console.log(' this.warehousesusers-----', this.warehousesusers)
    },

    async getProducts() {
        if (this.formData.seller) {
           const filters = {limit:200,seller: this.formData.seller._id||this.formData.seller,'details.country': this.warhouseId.country,creationOrder:this.warhouseId.country};
          // console.log('filter pr-----',filters)
            const res = await this.$server.search("products", filters);
            if (res.content.results) {
                this.products = res.content.results;
                this.paginate.total = res.content.total;
                this.paginate.lastpage = res.content.last_page;
                this.paginate.per_page = res.content.per_page;
                this.paginate.currentpage = res.content.current_page;
            //  console.log('this.products-----',this.products)
                for (let i in this.products) {
                  this.products[i].seller = this.products[i].seller;
                  const resProductW= this.getElementInArray(this.products[i].details,this.warhouseId._id);
                  if(resProductW && resProductW.price) this.products[i].price = resProductW.price;
                }
            } else this.products = [];
      } else {
        alert(this.$t('must_select_seller'), "warning");
      }
    },

    async getStatus() {
      const res = await this.$server.search("status");
      if (res.content.results) this.status = res.content.results;
      else this.status = [];
    },
      SumTotalPrice(data) {
       let total=0;
        for (let i in data) {
          total += data[i].quantity * data[i].unitPrice;
        }
        return total;
     },
    async save(checkParent=null) {
      if (this.formData._id) {
         this.loading=true;
         this.formData.totalPrice=this.SumTotalPrice(this.formData.details);
         this.formData.customer.phone= this.formData.customer.phone.replace(/[^\d]/g, ''); 
         this.formData.customer.country=this.selectContry;
          if(this.formData.customer.country==='MA') {
            let strFirstThree =  this.formData.customer.phone.substring(0,4);
            if(strFirstThree.indexOf('212') === -1) this.formData.customer.phone='+212'+this.formData.customer.phone;
          }
        const data = await this.$server.update("orders", this.formData);
        console.log('data-------------',data)
         this.loading=false;
        if (data && data._id) {
          // const shippingdata = await this.$server.get("shippings", {order: data._id,});
          //  if(shippingdata.content && shippingdata.content._id){
          //    shippingdata.content.orderObjet=this.formData;
          //    await this.$server.update("shippings", shippingdata.content);
          //  }
          this.formData.customer.country=this.$f.getCountryNameByCode(this.options,this.selectContry);
          alert(this.$t('order_updated'), "success");
          await this.dataToEdit();
        }else {alert(data, "warning");await this.dataToEdit();}
      } else {
        if (this.checkData()) {
          this.loading=true;
          if (['NRP', 'CEO', 'Return', 'CancelledOrder', 'TeleConsultant', 'Admin', 'ToRemind'].includes(this.currentUser.type)){
           console.log('comment -----',this.formData.comment)
          if(!checkParent){
            this.checkWraehouseParent=[];
            //check stock if exist
            console.log('sous_warehouses----',this.sous_warehouses)
            if(this.sous_warehouses.length>0){

                for (let index = 0; index < this.formData.details.length; index++) {
                    const orderLine = this.formData.details[index];
                    //  orderLine.warehouseParent=this.warhouseId._id;
                    //  orderLine.warehouseParentName=this.warhouseId.name;
                    const {content:product} = await this.$server.get("products",{  _id: orderLine.product._id||orderLine.product } )
                    //console.log('product -------',product)
                    let dataWhrahouse=this.$f.getElementInArrayByCountry(product.details,this.warhouseId.country,orderLine.quantity,'manuelCreate');
                    if(dataWhrahouse && dataWhrahouse.length>0){
                      this.checkWraehouseParent=dataWhrahouse.map(i => i.warehouse);
                      if(this.checkWraehouseParent.length == 1){
                          orderLine.warehouseParent=this.checkWraehouseParent[0]._id;
                          orderLine.warehouseParentName=this.checkWraehouseParent[0].name;
                      }
                    }else this.checkWraehouseParent=[] 
                }
            }
            console.log('checkWraehouseParent----',this.checkWraehouseParent)
            //  if(this.checkWraehouseParent.length>1){
            //      this.loading=false;
            //      console.log('oook')
            //      this.$vm2.open('warehouseParent');
            //      return false
            //  }


           

         }

         if (typeof this.formData.comment !== 'string' || this.formData.comment.trim() === '') {
              this.loading=false;
              this.$toast.warning("Commentaire est obligatoire");
              return false
         }

        //  if(checkParent && !this.formData.zone && this.currentUser.type != "Seller"){
        //      this.loading=false;
        //      alert('Ville de stockage required', "warning");
        //      return false
        //  }

        //  if(checkParent && this.formData.zone){
        //    for (let index = 0; index < this.formData.details.length; index++) {
        //          const orderLine = this.formData.details[index];
        //          orderLine.warehouseParent=this.formData.zone._id;
        //          orderLine.warehouseParentName=this.formData.zone.name;
        //    }
        //  }
         
       }

      //  if(!this.formData.zone && this.currentUser.type != "Seller"){
      //        this.loading=false;
      //        alert('Zone  required', "warning");
      //        return false
      //   }

        //check affiliate order
        if(this.formData.details.find(el=> el.product.type && el.product.type === 'affiliate')){
              if(this.formData.details.length>1) {this.loading = false;return this.$toast.warning("Order type affilitae contient seulment un produit type Offre");}
              this.formData.affiliate.type="affiliate";
          }else this.formData.affiliate={};

      
          this.formData.customer.country=this.selectContry;
          this.formData.totalPrice=this.SumTotalPrice(this.formData.details);
          this.formData.customer.phone= this.formData.customer.phone.replace(/[^\d]/g, ''); 

          let dataWhrahouseSetting=null;
          if(this.formData.seller.settings.length>0) dataWhrahouseSetting= this.getElementInArray(this.formData.seller.settings,this.warhouseId._id);
          if(!dataWhrahouseSetting || (dataWhrahouseSetting && !dataWhrahouseSetting.confirmation && !dataWhrahouseSetting.fulfillement && !dataWhrahouseSetting.shipping)){
            alert("vous n'avait pas activé aucun services veuillez contacter administration rmExpress", "warning");
             this.loading=false;
            return false;
          }
         
         

          const data = await this.$server.create("orders", this.formData);
          this.loading=false;
          if(data && data._id) {
            this.$vm2.close('warehouseParent');
            this.selectContry= "";
            this.formData.customer.country="";
            this.formData = {
              customer: {},
              details: [],
              affiliate:{},
            };
             if (this.currentUser.type == "Seller"){
              this.formData.seller = this.currentUser;
              if (this.formData.seller) this.isDisabled = false;
            }
            alert(this.$t('order_created'), "success");
          }else  alert(data, "warning");
        } else {
          alert(this.$t('all_required_field'), "warning");
        }
      }
    },
    checkData() {
      if (
        this.formData.customer.country &&
        this.formData.customer.phone &&
        this.formData.customer.fullName &&
        this.formData.customer.city &&
         this.formData.totalPrice &&
        this.formData.totalPrice>0 &&
        this.formData.details.length > 0 &&
        this.formData.customer
      )
        return true;
      else return false;
    },

    removeProduct(data, index) {
      this.$confirm(this.$t('confirm_delete_product')).then(
        async (res) => {
          var index = this.formData.details.findIndex(function(o){return o.product._id === data.product._id;})
           if (index !== -1) this.formData.details.splice(index, 1);
          data.product.check = false;
          alert(this.$t('product_deleted'), "success");
        }
      );
    },
    checkPrice(data){
      if(!data.price || parseInt(data.price)==0 || typeof data.price == 'undefined') return true
      else return false;
    },
    addProductsToTemp(data,id) {
      if (data.check) {
        const detail = {
          product: data,
          unitPrice: data.price||0,
          quantity: 1,
        };
        if (data.category) {
          if (data.category._id) {
            detail.category = data.category._id;
          } else {
          }
        }

        console.log("HIII JE SUIS DETAIL", detail);
        let found = 0;
        for (let i = 0; i < this.formData.details.length; i++) {
          if (this.formData.details[i].product._id == data._id) {
            found = found + 1;
            this.numberItemRepeated = this.numberItemRepeated + 1;
          }
        }
        if (found >= 1) {
        } else {
          this.productselected.push(detail);
        }
      } else {
        let pos = this.productselected
          .map(function (e) {
            return e.product._id;
          })
          .indexOf(data._id);
        this.productselected.splice(pos, 1);
      }
    },

    addQuantity(index) {
      this.formData.details[index].quantity++;
    },
    removeQuantity(index) {
      if (this.formData.details[index].quantity <= 1) {
      } else {
        this.formData.details[index].quantity--;
      }
    },

    async OpenPopUp() {
      if(!this.formData.customer.country){
        alert(this.$t('select_country'), "warning");
        return false;
      } 
      if (this.formData.seller) {
        await this.getProducts({});
        if (this.products.length > 0) {
          this.$vm2.open("myModal");
        } else {
          if (this.currentUser.type != "Seller")
            alert(this.$t('no_products_seller'), "warning");
          else alert(this.$t('no_product_added'), "warning");
          //console.log("HIIIIII JE SUIS LA");
        }
      }
    },
    ConfirmOperation() {
      let fount = 0;
      for (let i = 0; i < this.productselected.length; i++) {
        this.formData.details.push(this.productselected[i]);
      }
      
      this.productselected = [];
      if (this.numberItemRepeated > 0) {
        alert(this.$t('product_already_added'), "success");
      }
      this.numberItemRepeated = 0;
      this.$vm2.close("myModal");
    },
    closePopUp(name) {
      //console.log("close");
       this.$vm2.close(name);
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get("orders", {
          id: this.$route.params.id,
        });
        this.formData = editData.content;
         if (this.formData.seller) this.isDisabled = false;
        this.selectContry=this.formData.customer.country;
        this.formData.customer.country=this.$f.getCountryNameByCode(this.options,this.formData.customer.country);
        //console.log(this.formData);
        this.formData.date =this.$moment(this.formData.date).format('yyyy-MM-DDTHH:mm');
        if (this.currentUser && this.currentUser.type && this.currentUser.type != "Seller")  await this.getSellers(this.selectContry);
        await this.getCities(this.selectContry);
        await this.getFeesShippBycity(this.formData.customer.city);
        await this.getCurrencyBycontry(this.selectContry);
       
      }
    },
    async getSellers(country) {
      const filter = {
        type: "Seller",
        limit:10,
        countries:country
      };
      const res = await this.$server.search("users", filter);
      if (res.content.results) {this.sellers = res.content.results;this.sellerExists=true;}
      else this.sellers = [];
    },
    changeSeller(seller) {
       if (this.currentUser.type != "Seller" && seller) {
        this.isDisabled = false;
        if (this.formData.details) {
          if (this.formData.details[0]) {
            if (
              this.formData.details[0].product.seller !=
              seller._id
            ) {
              this.formData.details = [];
            }
          }
        }
      } else {
        this.isDisabled = true;
      }
    },
  },

  computed: {
    resultSearchUsers() {
      if (this.searchText) {
        return this.products.filter((product) => {
          var regex = new RegExp(this.searchText, "i");

          return regex.test(product.name);
        });
      } else {
        return this.products;
      }
    },
  },

  /************************************* Pagination **************************************************/
};
</script>

<style>
.toggle__dot {
  transition: all 0.3s ease-in-out;
}
input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #68d391;
}
/* animation for vue transition tag */
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}
dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}
@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.vs__dropdown-toggle {
    border: none;
} 
</style>
